import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetsheet = (id, enabled) => {
  const data = useQuery(["sheetDetail", id, enabled], () =>
    axiosClient.get(`/Sheet/GetSheetByIdToEdit?sheetId=${id}`), { 
      enabled: enabled,
      retry: false, 
      refetchOnWindowFocus: false, 
    }
  );

  return data;
};
export default useGetsheet;
